module.exports = __webpack_public_path__ + "img/cheackboxArrow.6bb1e162.svg";